module.exports = __webpack_public_path__ + "img/lottery-4.85fe228e.svg";